import { patch } from 'utils/api';

// Position/size for one layer — same request shape already used for the
// crop flow's layer update (see components/ImageEditor.js).
export const updateLayerPosition = (bookId, pageId, layerId, attributes) =>
  patch(`/v3/books/${bookId}/pages/${pageId}/layers/${layerId}`, { data: { attributes } });

// Query-param PATCH, no body — same convention already used for applying a
// page layout (see PageSlider.js's onPageSelection).
export const setPageLocked = (bookId, pageId, locked) =>
  patch(`/v3/books/${bookId}/pages/${pageId}?locked=${locked}`);
